import React from "react";
import { Typography, Stack, Box } from "@mui/material";
import { PieChart } from '@mui/x-charts/PieChart';
import { BarChart } from "@mui/x-charts/BarChart";
import Grid2 from "@mui/material/Unstable_Grid2";
import { useTheme } from '@mui/material/styles';
import MobileStepper from '@mui/material/MobileStepper';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
const DisplayGraphics = (props) => {
    const theme = useTheme();
    const [activeStep, setActiveStep] = React.useState(0);
    const maxSteps = props.report.length;

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    return (
        <Box>
            <Stack spacing={2}>
                <Typography variant="h2" textAlign='center'>{props.title}</Typography>
                <Stack alignItems='center' spacing={2} style={{ border: '3px solid #1E3D52'}}>
                    <Typography variant='h5' textAlign='center'>{props.report[activeStep].label}</Typography>
                    {(props.report[activeStep].type == 1 || props.report[activeStep].type == 3) && (
                        <PieChart
                            series={[
                                {
                                    data: props.report[activeStep].labels.map((curr, index) => ({
                                        id: index,
                                        value: props.report[activeStep].datos[curr],
                                        label: curr,
                                    })),
                                },
                            ]}
                            width={1500}
                            height={500}
                            margin={{ bottom: 100 }}
                            slotProps={{ legend: { direction: 'row', position: { vertical: 'bottom' }, padding: { top: 50 } } }}

                        />
                    )}
                    {props.report[activeStep].type == 2 && (
                        <BarChart
                            xAxis={[{ scaleType: 'band', data: ['1', '2', '3', '4', '5'], label: 'Puntuación' }]}
                            series={[{ data: [props.report[activeStep].datos['1'] != null ? props.report[activeStep].datos['1'] : 0, props.report[activeStep].datos['2'] != null ? props.report[activeStep].datos['2'] : 0, props.report[activeStep].datos['3'] != null ? props.report[activeStep].datos['3'] : 0, props.report[activeStep].datos['4'] != null ? props.report[activeStep].datos['4'] : 0, props.report[activeStep].datos['5'] != null ? props.report[activeStep].datos['5'] : 0], label: 'Respuestas' }]}
                            width={1500}
                            height={500}
                        />
                    )}
                </Stack>

                <MobileStepper
                    variant="text"
                    steps={maxSteps}
                    position="static"
                    activeStep={activeStep}
                    nextButton={
                        <Button
                            size="small"
                            onClick={handleNext}
                            disabled={activeStep === maxSteps - 1}
                        >
                            SIGUIENTE
                            {theme.direction === 'rtl' ? (
                                <KeyboardArrowLeft />
                            ) : (
                                <KeyboardArrowRight />
                            )}
                        </Button>
                    }
                    backButton={
                        <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                            {theme.direction === 'rtl' ? (
                                <KeyboardArrowRight />
                            ) : (
                                <KeyboardArrowLeft />
                            )}
                            ANTERIOR
                        </Button>
                    }
                />
            </Stack>
        </Box>
    );
};

export default DisplayGraphics;
